<template>
    <div class="OrderAmount-root">
        <info-box title="订单金额" :show-line="false">
            <template slot="info">
               <div class="table_content">
                    <costDetailsTable v-if="warehouseExpectedCostList.length" :columns="CostColumns" :table-list="warehouseExpectedCostList" title="仓预计费用：" :total-cost="orderDetail.warehouseCost" /> 
                    <costDetailsTable v-if="warehousePracticalCostList.length" :columns="CostColumns" :table-list="warehousePracticalCostList" title="仓实际费用：" :total-cost="warehouseActualCost" />
                    <costDetailsTable v-if="orderDetail.needTransport" :columns="orderAmount" :table-list="tableList" title="配预计费用：" :total-cost="totalCost" />
               </div>
            </template>
        </info-box>
    </div>
</template>

<script>
import InfoBox from './InfoBox.vue'
import costDetailsTable from './costDetailsTable.vue'
import {warehouseOrderCostList} from '../../api'

const orderTypeCode = {
    RK: '入库',
    CK: '出库'
}
const costType = {
    PLAN_INCOME:'PLAN_INCOME', // 计划应收
    ACTUAL_INCOME:'ACTUAL_INCOME', // 实际应收
}
export default {
    name: 'OrderAmount',
    components: {
        InfoBox,
        costDetailsTable,
    },
    props: {
        orderDetail: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            orderAmount: [
                {
                    title: '类型',
                    dataIndex: 'costName',
                    key: 'costName',
                    width: 100,
                    customRender: () => {
                        return '运输';
                    },
                },
                {
                    title: '费目',
                    dataIndex: 'costTypeName',
                    key: 'costTypeName',
                    width: 180,
                    customRender: (value) => {
                        return value || '--'
                    }
                },
                {
                    title: '金额（元）',
                    dataIndex: 'cost',
                    key: 'cost',
                    width: 100,
                    customRender: (value) => {
                        return value !== null ? `${value}元` : '暂未计算';
                    },
                },
            ],
             CostColumns: [
                {
                    title: '类型',
                    dataIndex: 'costName',
                    key: 'costName',
                    width: 100,
                    customRender: () => {
                        return '仓储';
                    },
                },
                {
                    title: '费目',
                    dataIndex: 'costType',
                    key: 'costType',
                    width: 180,
                    customRender: (value) => {
                        return value || '--'
                    }
                },
                {
                    title: '金额（元）',
                    dataIndex: 'cost',
                    key: 'cost',
                    width: 100,
                    customRender: (value) => {
                        return value !== null&&value !== undefined ? `${value}元` : '暂未计算';
                    },
                },
            ],
            listData: [
                {
                    key: '1',
                    costName: '12',
                    costDetail: [
                        {
                            costTypeName: '123123',
                            cost: 2333
                        },
                        {
                            costTypeName: '666',
                            cost: 123
                        }
                    ]
                }
            ],
            warehouseExpectedCostList:[{}], // 仓预计费用
            warehousePracticalCostList:[{}], // 仓实际费用
        }
    },
    computed: {
        transportCosts() {
            const transportCosts = this.orderDetail?.transportCosts ?? []
            return transportCosts.map(item => {
                return {
                    key: item.carrierTenantId || item.id,
                    costType: item.costType,
                    cost: item.cost.toFixed(2)
                }
            })
        },
        totalCost() {
            const completeList = this.tableList.filter((item) => !item.cost && item.cost !==0);
            if (completeList.length) {
                return null
            }
            return this.tableList.reduce((prev, next) => {
                return prev + parseFloat(next.cost, 10)
            }, 0).toFixed(2)
        },
        tableList(){
            const { orderDetail } = this;
            const tableList = []
            // 仓储
            let list = [];
            (orderDetail?.warehouseOrderResList || []).forEach(item => {
                const costItem = item.warehouseOrderCostList[0] || {};
                if (item.warehouseOrderCostList.length > 1) {
                    const costTypeList = [];
                    let cost = 0;
                    item.warehouseOrderCostList.forEach((l) => {
                    costTypeList.push(l.costType);
                    if (l.cost) {
                        cost += l.cost;
                    } else {
                        cost = null;
                    }
                    });
                    costItem.costType = costTypeList.join('/');
                    costItem.cost = cost;
                }
                list.push({
                    // ...item.warehouseOrderCostList[0] || {},
                    ...costItem,
                    orderType: item.orderType,
                })
            })
            list = list.length ? list : [{
                id: 'cangchu',
                costTypeName: '',
                cost: null,
            }]
            if(list && list.length > 0){
                const len = list.length > 1
                list.forEach((e, i, arr) => {
                    if(i === 0){
                        tableList.push({
                            ...e,
                            key: e.id,
                            costName: '仓储',
                            rowType: 111,
                            costTypeName: len ? `${e.costType ? e.costType : ''}(第${i+1}次仓库操作：${orderTypeCode[e.orderType]})` : e.costType,
                            cost: this.filterCost(orderDetail.ifWarehouseCancel, e.cost?.toFixed(2)),
                            rowSpan: arr.length
                        })
                    }else{
                        tableList.push({
                            ...e,
                            key: e.id,
                            costName: '仓储',
                            rowType: 111,
                            costTypeName: len ? `${e.costType ? e.costType : ''}(第${i+1}次仓库操作：${orderTypeCode[e.orderType]})` : e.costType,
                            cost: this.filterCost(orderDetail.ifWarehouseCancel, e.cost?.toFixed(2)),
                            rowSpan: 0
                        })
                    }
                })
            }

            // 运输
            // const {transportCostList} = orderDetail.orderMsgResList && this.orderDetail.orderMsgResList.length > 0 ? this.orderDetail.orderMsgResList[0] : {}
            const transportCostList = [];
            (orderDetail.orderMsgResList || []).forEach(item => {
                const costItem = item.transportCostList[0] || {};
                if (item.transportCostList.length > 1) {
                    const costTypeList = [];
                    let cost = 0;
                    item.transportCostList.forEach((l) => {
                    costTypeList.push(l.costType);
                    if (l.cost) {
                        cost += l.cost;
                    } else {
                        cost = null;
                    }
                    });
                    costItem.costType = costTypeList.join('/');
                    costItem.cost = cost;
                }
                transportCostList.push({
                    ...costItem,
                })
            })
            if(transportCostList){
                const len = transportCostList.length > 1
                transportCostList.forEach((e, i, arr) => {
                    
                    if(i === 0){
                        tableList.push({
                            ...e,
                            key: e.id,
                            costName: '运输',
                            costTypeName: len ? `${e.costType || ''}(第${i+1}次运输)` : e.costType,
                            cost: this.filterCost(orderDetail.ifTransportCancel, e.cost?.toFixed(2)),
                            rowSpan: arr.length
                        })
                    }else{
                        tableList.push({
                            ...e,
                            key: e.id,
                            costName: '运输',
                            costTypeName: len ? `${e.costType || ''}(第${i+1}次运输)` : e.costType,
                            cost: this.filterCost(orderDetail.ifTransportCancel, e.cost?.toFixed(2)),
                            rowSpan: 0
                        })
                    }
                })
            }
            return tableList
        },
        warehouseActualCost(){
            return this.orderDetail?.ext?.warehouseActualCost||null
        }
    },
    created () {
        this.warehouseOrderCostList()
    },
    mounted () {},
    methods: {
        async warehouseOrderCostList(){
            const res = await warehouseOrderCostList({
                unifyOdrNo: this.orderDetail.unifyOdrNo,
                costBizTypes:["PLAN_INCOME", "ACTUAL_INCOME"]
            })
        if(res&&res.length){
            this.warehouseExpectedCostList = res.some(item=>item.costBizType===costType.PLAN_INCOME)? res.filter(item=>item.costBizType===costType.PLAN_INCOME):[{}];
            this.warehousePracticalCostList = res.some(item=>item.costBizType===costType.ACTUAL_INCOME)? res.filter(item=>item.costBizType===costType.ACTUAL_INCOME):[{}];
        }else{
            this.warehouseExpectedCostList =  [{}];
            this.warehousePracticalCostList = [{}];
        }
        },
        filterCost(res, data){
            if(res){
                return 0
            }
            if(data){
                return data
            }
            return null
        },
    },
}
</script>

<style lang="less" scoped>
.OrderAmount-root {
    .total-cost {
        color: #808792;
        // font-weight: 500;
        font-size: 14px;
        .info-amount {
            color: #FF4830;
        }
        .no-calculate-amount {
            color: #999;
            font-weight: 400;
        }
    }
    
}
.table_content{
    display: flex;
}
</style>